export const ErrorDisplay = ({
  message = "",
  customStyle = "",
}) => {
  return (
    <div className={`flex justify-center items-center w-full ${customStyle}`}>
      <div className="bg-white p-6 rounded-lg shadow-md text-center max-w-md w-full">
        <div className="mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 mx-auto text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <title id="unexpectedErrorIconTitle">Unexpected Error icon</title>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 12h.01M15 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-800 mb-2 capitalize">
          Oops! Something went wrong
        </h3>
        {message ? (
          <p className="text-gray-600 mb-4">{message}</p>
        ) : (
          <p className="text-gray-600 mb-4">
            There could be a misconfiguration in the system or a service outage.  If the problem persists, please try again later or contact support.
          </p>
        )}
      </div>
    </div>
  );
};

export default ErrorDisplay;
